import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Col from 'reactstrap/lib/Col';
import Row from 'reactstrap/lib/Row';
import Button from 'reactstrap/lib/Button';
import classNames from 'classnames';
import './dealer-info-list.scss';

export class DealerInfoList extends Component {
  state = {
    showAllList: false,
  };

  toggleList = () => {
    this.setState({
      showAllList: !this.state.showAllList,
    });
  };

  render() {
    const { className, heading, list, columns, previewSize, trackingValue } = this.props;
    if (!(list && list.length)) return null;

    const { showAllList } = this.state;
    return (
      <div className={classNames('dealer-info-list medium', className, { open: showAllList })}>
        <div className="list-heading fw-bold">
          {heading}
          <Button
            onClick={this.toggleList}
            className="list-toggle float-end pe-0_5 py-0 hidden-md-up"
            data-tracking-id="ddp_view_dealer_details"
            data-tracking-value={trackingValue}
            aria-label={showAllList ? 'Hide details' : 'Show details'}
          >
            <span className={classNames({ 'icon-plus3': !showAllList, 'icon-minus3': showAllList })} />
          </Button>
        </div>
        <Row className="list-items list-unstyled mb-0" tag="ul">
          {list.map((item, index) => {
            if (showAllList)
              return (
                <Col key={item} xs={12} sm={12 / columns} className="list-item py-0_5" tag="li">
                  {item}
                </Col>
              );
            if (index + 1 > previewSize) return null;
            return (
              <Col key={item} xs={12} sm={12 / columns} className="list-item py-0_5" tag="li">
                {item}
              </Col>
            );
          })}
        </Row>
        {list.length > previewSize && (
          <Button
            color="link"
            className="list-view-all-button small px-0 hidden-md-down text-transform-none text-underline fw-normal"
            onClick={this.toggleList}
            data-tracking-id="ddp_view_dealer_details"
            data-tracking-value={trackingValue}
          >
            Show {showAllList ? 'less' : 'all'}
            <span
              className={classNames('ms-0_25 small', {
                'icon-arrow-up2': showAllList,
                'icon-arrow-down2': !showAllList,
              })}
              aria-hidden
            />
          </Button>
        )}
      </div>
    );
  }
}

DealerInfoList.propTypes = {
  className: PropTypes.string,
  heading: PropTypes.string.isRequired,
  list: PropTypes.arrayOf(PropTypes.string),
  columns: PropTypes.number,
  previewSize: PropTypes.number,
  trackingValue: PropTypes.string,
};

DealerInfoList.defaultProps = {
  className: '',
  list: [],
  columns: 1,
  previewSize: 5,
  trackingValue: '',
};
